var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import camelCase from 'lodash/camelCase';
import React, { useContext } from 'react';
import { Button, Icon, Link } from '@honda-canada/design-system-react';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import { ModelExplorationContext } from '../ModelExplorationContext';
import { wrapJSSFields } from '../../utils/wrapJSSFields';
import { useAppName } from '../../utils/sitecoreContext';
import { PE_SITE_NAME } from '../../utils/constants';
var CTA = function (_a) {
    var linkField = _a.linkField, typeField = _a.typeField, iconField = _a.iconField, icon = _a.icon, iconColor = _a.iconColor, parentGtmTags = _a.parentGtmTags, otherProps = __rest(_a, ["linkField", "typeField", "iconField", "icon", "iconColor", "parentGtmTags"]);
    var modelExplorationContext = useContext(ModelExplorationContext) || {};
    var isDark = modelExplorationContext.isDark;
    var styling = camelCase(typeField === null || typeField === void 0 ? void 0 : typeField.value);
    // TODO: Temporary fix for PE. Fix the tertiaryLink for PE (PSP Theme) in DSR later.
    var tertiaryLink = 'primary';
    var appName = useAppName();
    switch (appName) {
        case PE_SITE_NAME:
            tertiaryLink = styling === 'tertiary' ? 'tertiary2' : 'primary';
            break;
        default:
            break;
    }
    var wrappedIcon = wrapJSSFields(iconField).fields;
    var iconName = icon || (wrappedIcon === null || wrappedIcon === void 0 ? void 0 : wrappedIcon.getProp('value'));
    var darkStyling = styling === 'secondary' ? 'specialSecondary' : 'special';
    if (styling === 'tertiary' || styling === 'tertiaryWhite') {
        return (React.createElement("span", __assign({}, parentGtmTags),
            React.createElement(Link, __assign({ styling: isDark || styling === 'tertiaryWhite' ? 'white' : tertiaryLink, as: RoutableSitecoreLink, field: linkField }, otherProps)),
            iconName && React.createElement(Icon, { ml: "xs", height: "10px", iconColor: isDark ? 'red' : iconColor || 'primary', name: iconName })));
    }
    return (React.createElement(Button, __assign({ styling: isDark ? darkStyling : styling, as: RoutableSitecoreLink, field: linkField }, otherProps)));
};
export default CTA;
